const ShatteredBeliefs = () => (
    <section id="shattered-beliefs">
        <div className="container-fluid py-4 text-center gg-bg-gradient-rb-h text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-xl-6 col-lg-7 col-md-8 col-11 text-md-start text-center">
                    <h3 className="my-3 fw-bold text-md-center">The Turning Point That Shattered My Beliefs</h3>
                    <p className="pt-4">
                        My life didn’t change because of a doctor’s lecture.<br />
                        Or a pamphlet.<br />
                        Or some motivational quote on the internet.<br />
                    </p>
                    <h4 className="fw-bold my-4">It changed when I saw undeniable proof.</h4>
                    <p>
                        A real person who’d done what I was told couldn’t be done.<br/>
                        Someone living with type 2 diabetes.<br/>
                        Not just controlling it with stricter routines or tighter rules…
                    </p>
                    <p className="fw-bold my-3">But actually living a full life. A joyful one. Without guilt, fear, or limits.</p>
                    <p>The kind of story you expect to see in a documentary… or dream about and then wake up disappointed.</p>
                    <p>
                        But this one?<br/>
                        <span className="fw-bold fs-5 lh-1">This became <i>my</i> reality.</span>
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default ShatteredBeliefs;